import { render, staticRenderFns } from "./BtnAtualizarSeguros.vue?vue&type=template&id=502ff679&"
import script from "./BtnAtualizarSeguros.vue?vue&type=script&lang=js&"
export * from "./BtnAtualizarSeguros.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports